import styles from './Branding.module.css';

interface Props {
    width?: number;
    height?: number;
    className?: string;
}

export default function Branding(props: Props) {
    const width = props.width ?? 140;
    const height = props.height ?? 30;
    const inlineStyles = {
        width: `${width}px`, // Use the defaulted width variable
        height: `${height}px`, // Use the defaulted height variable
    };

    const combinedClassName = [styles.branding, props.className].filter(Boolean).join(' ');

    return (
        // It seems the branding.svg is intended to be used here.
        // For example: <img src={branding} alt="Branding Logo" className={combinedClassName} style={inlineStyles} />
        // Or as a background image via CSS.
        // For now, leaving the div structure as is, but applying combined classes.
        <div className={combinedClassName} style={inlineStyles}>
        </div>
    );
}
